import {store} from "../Redux/store";
import { addAppOnlineStatus } from "../Redux/feature/appOnlineSlice";
import { reconnect } from "./Reconnect";
import { updateconnStatus } from "../Redux/feature/connectionStatusSlice";
import { setConnectionStatus } from "../Components/WebChat/Common/FileUploadValidation";
import { CONNECTION_STATE_DISCONNECTED } from "./Chat/Constant";


const isOnline = () => {
    setTimeout(() => {
        store.dispatch(addAppOnlineStatus(true));
        reconnect()
    }, 1500);
}
const isOffline = () => {
    store.dispatch(addAppOnlineStatus(false));
    // Update connection status
    setConnectionStatus(CONNECTION_STATE_DISCONNECTED);
    store.dispatch(updateconnStatus(CONNECTION_STATE_DISCONNECTED));
}

// Register window event listener
export const registerWindowEvent = () => {

    if (window.addEventListener) {
        window.addEventListener("online", ()=> isOnline(), false);
        window.addEventListener("offline", ()=> isOffline(), false);
    }
    else {
        document.body.ononline = isOnline;
        document.body.onoffline = isOffline;
    }
}
